import axios from 'axios'

export function useBpmDictionaries ({ policy, user, notify, dictionaries }) {
  function getManagers () {
    dictionaries.loading.managers = true
    axios.get('/api/dictionaries/order/managers')
      .then(res => {
        if (res.data.result) dictionaries.managers = res.data.data
      })
      .catch(err => notify.error({ message: err?.response?.data?.message ?? err.message }))
      .finally(() => {
        dictionaries.loading.managers = false
        if (user.value.role === 3) {
          policy.manager = user.value.id
          dictionaries.disabled.manager = true
        }
        if (user.value.role === 4 || user.value.role === 8) {
          if (dictionaries.managers.length) {
            policy.manager = dictionaries.managers[0].id
            dictionaries.disabled.manager = true
          }
        }
      })
  }

  function loadAgentsByManager (managerId) {
    if (managerId) {
      policy.agent = null
      dictionaries.loading.agents = true
      const headers = { id: managerId, product: policy.product }
      axios.post('/api/dictionaries/order/agents', headers)
        .then(res => {
          if (res.data.result && res.data.data) dictionaries.agents = res.data.data
          if (user.value.role === 4) {
            if (dictionaries.agents.length) {
              policy.agent = user.value.id
              dictionaries.disabled.agent = true
            }
          }
        })
        .catch(err => notify.error({ message: err?.response?.data?.message ?? err.message }))
        .finally(() => { dictionaries.loading.agents = false })
    } else {
      dictionaries.agents = []
    }
  }

  return {
    getManagers,
    loadAgentsByManager,
  }
}
